// extracted by mini-css-extract-plugin
module.exports = {"title":"NavList_title__DCLuO","nav_item":"NavList_nav_item__1tjhj"};